import { SET_CUSTOM_PAGES } from './types'

export const setCustomPages = pages => ({
  type: SET_CUSTOM_PAGES,
  pages
})
